// Mock data for TMB Global News. This will be replaced by live backend data.
// All content is original placeholder text themed around Michigan, USA.

export const CATEGORIES = [
  { slug: 'headlines', label: 'Headline News' },
  { slug: 'politics', label: 'Politics' },
  { slug: 'sport', label: 'Sport' },
  { slug: 'financials', label: 'Financials' },
  { slug: 'fashion', label: 'Fashion' },
];

export const MICHIGAN_CITIES = [
  'Detroit', 'Grand Rapids', 'Lansing', 'Ann Arbor', 'Flint',
  'Kalamazoo', 'Traverse City', 'Warren', 'Dearborn', 'Sterling Heights',
];

const img = (u, w = 900) => `${u}${u.includes('?') ? '&' : '?'}w=${w}&q=80&auto=format&fit=crop`;

export const ARTICLES = [
  // ---------------- HEADLINES ----------------
  {
    id: 'h1', category: 'headlines', city: 'Detroit', isFeatured: true, isBreaking: true,
    title: 'Detroit unveils sweeping riverfront revival plan to reconnect the city to the water',
    excerpt: 'City leaders announced a multi-phase investment that promises new parks, mixed-use districts and thousands of jobs along the Detroit River.',
    image: img('https://images.unsplash.com/photo-1643507246388-f58d54b2254f'),
    source: 'TMB Global Desk', author: 'Marcus Reed', publishedAt: '2025-07-14T13:20:00Z', readTime: 5,
  },
  {
    id: 'h2', category: 'headlines', city: 'Grand Rapids', isFeatured: true,
    title: 'Grand Rapids named among fastest-growing tech hubs in the Midwest',
    excerpt: 'A new report highlights a surge in startup funding and skilled-worker migration reshaping West Michigan.',
    image: img('https://images.unsplash.com/photo-1652700841019-69605b0211d3'),
    source: 'TMB Global Desk', author: 'Elena Powell', publishedAt: '2025-07-14T11:05:00Z', readTime: 4,
  },
  {
    id: 'h3', category: 'headlines', city: 'Ann Arbor', isFeatured: true,
    title: 'University of Michigan launches statewide clean-energy research initiative',
    excerpt: 'The program pairs researchers with local manufacturers to accelerate battery and solar innovation across the state.',
    image: img('https://images.unsplash.com/photo-1568267938179-f50e67de5ffc'),
    source: 'TMB Global Desk', author: 'Priya Nair', publishedAt: '2025-07-14T09:40:00Z', readTime: 6,
  },
  {
    id: 'h4', category: 'headlines', city: 'Lansing',
    title: 'State budget agreement clears the way for road and bridge repairs',
    excerpt: 'Lawmakers reached a bipartisan deal directing new funding to Michigan\u2019s aging infrastructure network.',
    image: img('https://images.unsplash.com/photo-1696943444991-def9485f89f8'),
    source: 'TMB Global Desk', author: 'David Cho', publishedAt: '2025-07-14T08:15:00Z', readTime: 4,
  },
  {
    id: 'h5', category: 'headlines', city: 'Flint',
    title: 'Flint community groups celebrate opening of new neighborhood health center',
    excerpt: 'The facility will expand access to primary and preventive care for thousands of residents.',
    image: img('https://images.unsplash.com/photo-1563029295-f4441b6a7860'),
    source: 'TMB Global Desk', author: 'Sara Whitfield', publishedAt: '2025-07-13T18:50:00Z', readTime: 3,
  },
  {
    id: 'h6', category: 'headlines', city: 'Traverse City',
    title: 'Record tourism season boosts small businesses across northern Michigan',
    excerpt: 'Warm weather and new festivals are drawing visitors to the Great Lakes coastline in record numbers.',
    image: img('https://images.unsplash.com/photo-1602276119677-a0230a8f504f'),
    source: 'TMB Global Desk', author: 'Grace Lin', publishedAt: '2025-07-13T16:30:00Z', readTime: 3,
  },
  {
    id: 'h7', category: 'headlines', city: 'Kalamazoo',
    title: 'Kalamazoo expands free-tuition promise to more graduating seniors',
    excerpt: 'An enlarged scholarship program aims to keep local talent studying and working in the region.',
    image: img('https://images.unsplash.com/photo-1631548637245-043803a8b776'),
    source: 'TMB Global Desk', author: 'Tom Baker', publishedAt: '2025-07-13T14:10:00Z', readTime: 4,
  },
  {
    id: 'h8', category: 'headlines', city: 'Warren',
    title: 'Auto suppliers in Macomb County ramp up hiring for electric-vehicle lines',
    excerpt: 'Manufacturers are retooling plants and adding shifts to meet demand for next-generation vehicles.',
    image: img('https://images.unsplash.com/photo-1594655151525-cc979fc9bf8b'),
    source: 'TMB Global Desk', author: 'Nadia Rahman', publishedAt: '2025-07-13T10:00:00Z', readTime: 5,
  },

  // ---------------- POLITICS ----------------
  {
    id: 'p1', category: 'politics', city: 'Lansing', isFeatured: true,
    title: 'Michigan legislature advances package aimed at lowering prescription costs',
    excerpt: 'The bills would create new oversight of drug pricing and expand assistance for seniors statewide.',
    image: img('https://images.unsplash.com/photo-1637768316226-44d97e7d6af4'),
    source: 'TMB Global Desk', author: 'Robert Hayes', publishedAt: '2025-07-14T12:00:00Z', readTime: 5,
  },
  {
    id: 'p2', category: 'politics', city: 'Lansing', isFeatured: true,
    title: 'Governor signs order to modernize state permitting for clean manufacturing',
    excerpt: 'Officials say the streamlined process could shave months off major project timelines.',
    image: img('https://images.unsplash.com/photo-1573181759662-1c146525b21f'),
    source: 'TMB Global Desk', author: 'Angela Torres', publishedAt: '2025-07-14T10:20:00Z', readTime: 4,
  },
  {
    id: 'p3', category: 'politics', city: 'Detroit',
    title: 'Detroit city council debates new affordable-housing incentives',
    excerpt: 'Members weighed tax measures designed to keep long-time residents in revitalizing neighborhoods.',
    image: img('https://images.unsplash.com/photo-1594581979864-36977b15d0dc'),
    source: 'TMB Global Desk', author: 'James Whitaker', publishedAt: '2025-07-13T17:45:00Z', readTime: 4,
  },
  {
    id: 'p4', category: 'politics', city: 'Ann Arbor',
    title: 'Local clerks prepare for higher turnout with expanded early voting sites',
    excerpt: 'County officials outlined new locations and staffing to make voting more accessible this cycle.',
    image: img('https://images.unsplash.com/photo-1494172961521-33799ddd43a5'),
    source: 'TMB Global Desk', author: 'Monica Reyes', publishedAt: '2025-07-13T13:30:00Z', readTime: 3,
  },
  {
    id: 'p5', category: 'politics', city: 'Grand Rapids',
    title: 'West Michigan mayors form coalition to tackle regional transit gaps',
    excerpt: 'The group will pursue shared funding for bus rapid transit and cross-county routes.',
    image: img('https://images.unsplash.com/photo-1534293230397-c067fc201ab8'),
    source: 'TMB Global Desk', author: 'Kevin Osei', publishedAt: '2025-07-13T09:15:00Z', readTime: 4,
  },
  {
    id: 'p6', category: 'politics', city: 'Flint',
    title: 'State approves additional funding to replace remaining lead service lines',
    excerpt: 'The allocation supports the final phase of a years-long effort to modernize water systems.',
    image: img('https://images.unsplash.com/photo-1540908390241-82158ab62887'),
    source: 'TMB Global Desk', author: 'Laura Simmons', publishedAt: '2025-07-12T19:00:00Z', readTime: 5,
  },

  // ---------------- SPORT ----------------
  {
    id: 's1', category: 'sport', city: 'Detroit', isFeatured: true,
    title: 'Lions open training camp with high expectations and a healthy roster',
    excerpt: 'Coaches say the team\u2019s depth and offseason moves have fans dreaming of a deep playoff run.',
    image: img('https://images.unsplash.com/photo-1557174949-3b1f5b2e8fac'),
    source: 'TMB Global Desk', author: 'Chris Donnelly', publishedAt: '2025-07-14T12:40:00Z', readTime: 4,
  },
  {
    id: 's2', category: 'sport', city: 'Detroit', isFeatured: true,
    title: 'Pistons add veteran leadership ahead of pivotal rebuilding season',
    excerpt: 'The front office is betting that experience will accelerate the development of a young core.',
    image: img('https://images.unsplash.com/photo-1537882111161-c3379a777c8b'),
    source: 'TMB Global Desk', author: 'Marcus Reed', publishedAt: '2025-07-14T10:50:00Z', readTime: 4,
  },
  {
    id: 's3', category: 'sport', city: 'Ann Arbor',
    title: 'Michigan football unveils new facility upgrades for student athletes',
    excerpt: 'The investment includes recovery labs, nutrition centers and expanded practice space.',
    image: img('https://images.unsplash.com/photo-1581852549708-72910bd52cff'),
    source: 'TMB Global Desk', author: 'Elena Powell', publishedAt: '2025-07-13T18:20:00Z', readTime: 3,
  },
  {
    id: 's4', category: 'sport', city: 'East Lansing',
    title: 'Spartans basketball lands standout recruit from the Detroit area',
    excerpt: 'The signing is being called one of the program\u2019s most important in recent years.',
    image: img('https://images.unsplash.com/photo-1572454181157-0b40dd7667fe'),
    source: 'TMB Global Desk', author: 'David Cho', publishedAt: '2025-07-13T15:05:00Z', readTime: 3,
  },
  {
    id: 's5', category: 'sport', city: 'Detroit',
    title: 'Red Wings prospects impress at summer development camp',
    excerpt: 'Young talent is giving the franchise reasons for optimism heading into the new season.',
    image: img('https://images.unsplash.com/photo-1580748141549-71748dbe0bdc'),
    source: 'TMB Global Desk', author: 'Grace Lin', publishedAt: '2025-07-13T11:30:00Z', readTime: 4,
  },
  {
    id: 's6', category: 'sport', city: 'Grand Rapids',
    title: 'Griffins announce community hockey program for West Michigan youth',
    excerpt: 'The initiative will provide equipment and coaching to hundreds of first-time skaters.',
    image: img('https://images.unsplash.com/photo-1545471977-94cac22e71ed'),
    source: 'TMB Global Desk', author: 'Tom Baker', publishedAt: '2025-07-12T16:00:00Z', readTime: 3,
  },

  // ---------------- FINANCIALS ----------------
  {
    id: 'fi1', category: 'financials', city: 'Detroit', isFeatured: true,
    title: 'Michigan manufacturing output climbs as EV investment accelerates',
    excerpt: 'New plant expansions and supplier contracts are lifting the state\u2019s industrial outlook.',
    image: img('https://images.unsplash.com/photo-1613871758600-fb390c5d3fbb'),
    source: 'TMB Global Desk', author: 'Nadia Rahman', publishedAt: '2025-07-14T13:00:00Z', readTime: 5,
  },
  {
    id: 'fi2', category: 'financials', city: 'Grand Rapids', isFeatured: true,
    title: 'West Michigan startups raise record venture funding this quarter',
    excerpt: 'Investors are pouring capital into local health-tech and advanced-manufacturing ventures.',
    image: img('https://images.unsplash.com/photo-1758830596893-7aa7c7caf245'),
    source: 'TMB Global Desk', author: 'Kevin Osei', publishedAt: '2025-07-14T11:15:00Z', readTime: 4,
  },
  {
    id: 'fi3', category: 'financials', city: 'Detroit',
    title: 'Home prices across metro Detroit steady as inventory improves',
    excerpt: 'Analysts point to a more balanced market as new listings ease buyer competition.',
    image: img('https://images.unsplash.com/photo-1699884745550-07d309f2f61d'),
    source: 'TMB Global Desk', author: 'Angela Torres', publishedAt: '2025-07-13T17:00:00Z', readTime: 4,
  },
  {
    id: 'fi4', category: 'financials', city: 'Lansing',
    title: 'State pension fund reports solid annual returns for public employees',
    excerpt: 'Officials credited diversified holdings and disciplined long-term strategy.',
    image: img('https://images.unsplash.com/photo-1594655151525-cc979fc9bf8b'),
    source: 'TMB Global Desk', author: 'Robert Hayes', publishedAt: '2025-07-13T12:20:00Z', readTime: 5,
  },
  {
    id: 'fi5', category: 'financials', city: 'Ann Arbor',
    title: 'Small-business confidence rises across Michigan, survey finds',
    excerpt: 'Owners cite steady demand and easing costs as reasons for cautious optimism.',
    image: img('https://images.unsplash.com/photo-1602276119677-a0230a8f504f'),
    source: 'TMB Global Desk', author: 'Sara Whitfield', publishedAt: '2025-07-12T15:40:00Z', readTime: 3,
  },
  {
    id: 'fi6', category: 'financials', city: 'Detroit',
    title: 'Michigan exports grow as global demand for auto parts rebounds',
    excerpt: 'Trade data shows renewed momentum for the state\u2019s manufacturing sector.',
    image: img('https://images.unsplash.com/photo-1643507246388-f58d54b2254f'),
    source: 'TMB Global Desk', author: 'James Whitaker', publishedAt: '2025-07-12T10:10:00Z', readTime: 4,
  },

  // ---------------- FASHION ----------------
  {
    id: 'fa1', category: 'fashion', city: 'Detroit', isFeatured: true,
    title: 'Detroit designers take center stage at summer runway showcase',
    excerpt: 'Local labels blended industrial heritage with bold color in a celebrated collection.',
    image: img('https://images.unsplash.com/photo-1554881070-74595ca2b74c'),
    source: 'TMB Global Desk', author: 'Grace Lin', publishedAt: '2025-07-14T12:10:00Z', readTime: 4,
  },
  {
    id: 'fa2', category: 'fashion', city: 'Ann Arbor', isFeatured: true,
    title: 'Sustainable fashion pop-ups gain a loyal following in Michigan',
    excerpt: 'Shoppers are embracing upcycled and locally made apparel at seasonal markets.',
    image: img('https://images.unsplash.com/photo-1554882195-8cf792f9a571'),
    source: 'TMB Global Desk', author: 'Priya Nair', publishedAt: '2025-07-14T09:50:00Z', readTime: 3,
  },
  {
    id: 'fa3', category: 'fashion', city: 'Grand Rapids',
    title: 'Street style thrives as West Michigan embraces bold summer looks',
    excerpt: 'From vintage denim to statement accessories, local trends are turning heads.',
    image: img('https://images.unsplash.com/photo-1532332248682-206cc786359f'),
    source: 'TMB Global Desk', author: 'Elena Powell', publishedAt: '2025-07-13T16:15:00Z', readTime: 3,
  },
  {
    id: 'fa4', category: 'fashion', city: 'Detroit',
    title: 'Michigan boutiques report strong demand for made-in-USA labels',
    excerpt: 'Owners say customers increasingly want quality pieces with a local story.',
    image: img('https://images.unsplash.com/photo-1624911104820-5316c700b907'),
    source: 'TMB Global Desk', author: 'Monica Reyes', publishedAt: '2025-07-13T12:40:00Z', readTime: 4,
  },
  {
    id: 'fa5', category: 'fashion', city: 'Traverse City',
    title: 'Resort-town boutiques set the pace for northern Michigan style',
    excerpt: 'Coastal-inspired collections are the season\u2019s must-have for visitors and locals alike.',
    image: img('https://images.unsplash.com/photo-1441984904996-e0b6ba687e04'),
    source: 'TMB Global Desk', author: 'Tom Baker', publishedAt: '2025-07-12T14:25:00Z', readTime: 3,
  },
  {
    id: 'fa6', category: 'fashion', city: 'Detroit',
    title: 'Emerging Michigan stylists build national followings online',
    excerpt: 'A new generation of creators is putting the state on the fashion map.',
    image: img('https://images.unsplash.com/photo-1555529771-835f59fc5efe'),
    source: 'TMB Global Desk', author: 'Nadia Rahman', publishedAt: '2025-07-12T09:30:00Z', readTime: 4,
  },
];

// Build a realistic multi-paragraph body from an excerpt (placeholder content)
export function buildBody(article) {
  const c = article.city;
  return [
    article.excerpt,
    `The developments in ${c} come amid growing attention to how communities across Michigan are adapting to a fast-changing economic and social landscape. Officials and residents alike say the coming months will be decisive.`,
    `\u201cWe are focused on outcomes that residents can see and feel,\u201d a local representative said. \u201cThis is about building something durable for families and businesses in ${c} and across the state.\u201d`,
    `Analysts note that similar efforts in other parts of Michigan have produced mixed but encouraging results. Supporters argue that sustained investment and community engagement are essential to long-term success.`,
    `TMB Global News will continue to follow this story and provide updates as they develop. Readers are encouraged to check back for the latest coverage from ${c} and the wider region.`,
  ];
}

export const TICKER_ITEMS = [
  { symbol: 'DOW', name: 'Dow Jones', price: 40213.45, change: 0.62 },
  { symbol: 'S&P 500', name: 'S&P 500', price: 5498.12, change: 0.34 },
  { symbol: 'NASDAQ', name: 'Nasdaq', price: 17842.90, change: -0.21 },
  { symbol: 'F', name: 'Ford Motor', price: 12.84, change: 1.42 },
  { symbol: 'GM', name: 'General Motors', price: 48.17, change: -0.58 },
  { symbol: 'DTE', name: 'DTE Energy', price: 116.35, change: 0.28 },
  { symbol: 'WHR', name: 'Whirlpool', price: 105.62, change: -1.05 },
  { symbol: 'KELYA', name: 'Kelly Services', price: 20.41, change: 0.74 },
  { symbol: 'GLD', name: 'Gold', price: 2398.60, change: 0.44 },
  { symbol: 'WTI', name: 'Crude Oil', price: 81.22, change: -0.63 },
];

export const WEATHER = [
  { city: 'Detroit', temp: 79, condition: 'Partly Cloudy', code: 2, high: 83, low: 66, wind: 8, humidity: 54 },
  { city: 'Grand Rapids', temp: 77, condition: 'Sunny', code: 0, high: 81, low: 63, wind: 6, humidity: 48 },
  { city: 'Lansing', temp: 78, condition: 'Cloudy', code: 3, high: 80, low: 64, wind: 10, humidity: 57 },
  { city: 'Ann Arbor', temp: 80, condition: 'Sunny', code: 1, high: 84, low: 65, wind: 7, humidity: 50 },
  { city: 'Flint', temp: 76, condition: 'Light Rain', code: 61, high: 79, low: 62, wind: 11, humidity: 68 },
  { city: 'Traverse City', temp: 74, condition: 'Partly Cloudy', code: 2, high: 77, low: 60, wind: 9, humidity: 61 },
];

export const AD_SLOTS = {
  leaderboard: {
    title: 'Advertise to over 5 million people locally and globally',
    subtitle: 'Place your ad here \u2014 reach Michigan and the world with TMB Global News',
    cta: 'Place Your Ad Here',
  },
  sidebar: [
    { size: '300 \u00d7 250', label: 'Your Ad Here', note: 'Premium sidebar placement' },
    { size: '300 \u00d7 600', label: 'Your Ad Here', note: 'Half-page skyscraper' },
    { size: '300 \u00d7 250', label: 'Your Ad Here', note: 'Below-the-fold spotlight' },
  ],
  inline: { size: '728 \u00d7 90', label: 'Your Ad Here', note: 'Leaderboard banner' },
};

export function timeAgo(iso) {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const diff = Math.max(0, Math.floor((now - then) / 1000));
  if (diff < 60) return 'just now';
  const m = Math.floor(diff / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
